module.exports = __webpack_public_path__ + "static/media/__carousel.global.9539b17e.less";